import { createSlice } from "@reduxjs/toolkit";

const initialProjectState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  projectForEdit: undefined,
  lastError: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const projectSlice = createSlice({
  name: "project",
  initialState: initialProjectState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getProjectById
    projectFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.projectForEdit = action.payload.projectForEdit;
    },

    // getProjectManage
    projectManage: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.projectManage = action.payload.projectManage;
    },
    // findProject
    projectsFetched: (state, action) => {
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = items;
      state.totalCount = total_items;
    },
    // Set to default state actionLoading & error
    projectReload: (state, action) => {
      state.actionsLoading = false;
      state.listLoading = false;
      state.error = null;
    },

    // findDonationsItem
    donationItemsFetched: (state, action) => {
      // const { total_items, items, donation_item_array } = action.payload;
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.donationItems = items;
      state.totalCount = total_items;
      // state.donation_item_array = donation_item_array
    },

    // findIncomeItem
    incomeItemsFetched: (state, action) => {
      // const { total_items, items, donation_item_array } = action.payload;
      const { total_items, items } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.incomeItems = items;
      state.totalCount = total_items;
      // state.donation_item_array = donation_item_array
    },
  },
});
